import { atomWithStorage } from 'jotai/utils';
export const languageAtom = atomWithStorage('app_language', 'zh-CN');
